import React from "react";
import { Typography, Box, Divider } from "@mui/material";
import { formatCurrency } from "../../services/valueFormatters";

const RASummary = ({ 
  subtotal, 
  taxes, 
  retainedISR = 0, 
  retainedIVA = 0, 
  totalIVA = 0, 
  totalRetention = 0, 
  paymentTotal = 0, 
  total = 0 
}) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Subtotal: {formatCurrency(subtotal)}
      </Typography>
      
      <Typography variant="h6" gutterBottom>
        IVA Total: {formatCurrency(totalIVA || taxes)}
      </Typography>
      
      <Divider sx={{ my: 1 }} />
      
      <Typography variant="h6" color="primary" gutterBottom>
        Retenciones:
      </Typography>
      
      <Box sx={{ ml: 2 }}>
        <Typography variant="body1">
          ISR Retenido: {formatCurrency(retainedISR)}
        </Typography>
        <Typography variant="body1">
          IVA Retenido: {formatCurrency(retainedIVA)}
        </Typography>
        <Typography variant="h6" color="error">
          Total Retenciones: {formatCurrency(totalRetention)}
        </Typography>
      </Box>
      
      <Divider sx={{ my: 1 }} />
      
      <Typography variant="h6" gutterBottom>
        Total: {formatCurrency(total || (subtotal + (totalIVA || taxes)))}
      </Typography>
      
      <Typography variant="h5" color="success.main" gutterBottom>
        Total a Pagar: {formatCurrency(paymentTotal || (subtotal + (totalIVA || taxes) - totalRetention))}
      </Typography>
    </Box>
  );
};

export default RASummary;
